import React from 'react'
// import "../../../../"
import "../../../../../styles/ComponentsStyles/Organizational/Management/Structure/ProfileInfoCard.styles.css"
import PropTypes from 'prop-types'

const ProfileInfoCard = ({ name, profileImage, role, color }) => {
  return (
    <div className="structureProfileInfoCard">
      <img src={profileImage} alt="" />
      <div className="profileDetails">
        <span>{name}</span>
        <span>{role}</span>
      </div>
      <div className="colorBand" style={{ "--structure-color-band": color }}></div>
    </div>
  )
}

export default ProfileInfoCard
ProfileInfoCard.propTypes = {
  name: PropTypes.string.isRequired,
  profileImage: PropTypes.element.isRequired,
  role: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
}